module.exports = __webpack_public_path__ + "static/media/dont4.b8d55140.png";